import React from 'react';

import { currentUser, duckify } from "utils/duckify";

import CustomerNote from './CustomerNote';
import AddNewFeeGroup from '../feeManagement/AddNewFeeGroup';

const FeeManagementPage = () => {
  return (
    <div>
      <div id="note-component">
        <CustomerNote userName={currentUser.name} pageName={'fee_management'} />
      </div>
      <div>
        <div className="title-row">
          <h2>Custom Form Fees</h2>
          <div className="fee-management-instructions">
            This page allows you to create and manage custom fees that are tied to forms within your Admissions or Enrollment workflow.
            <ul>
              <li>
                <i className="fa fa-list-alt"></i>
                You can create custom fee groups that contain related types of fees.
              </li>
              <li>
                <i className="fa fa-usd"></i>
                Each fee within a fee group can have conditions (fee rules) that determine if the fee will apply to a student.
              </li>
              <li>
                <i className="fa fa-check-square-o"></i>
                All fee groups must be associated with a custom online form checklist item.
              </li>
            </ul>
          </div>
          <AddNewFeeGroup />
        </div>
      </div>
    </div>
  )
}

const mapDucksToProps = () => ({ currentUser });

export default duckify(mapDucksToProps)(FeeManagementPage);